import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Loader2, Play, ShieldCheck } from 'lucide-react';

const lastQuarter = () => {
  const now = new Date();
  const quarterStartMonth = Math.floor(now.getMonth() / 3) * 3;
  const end = new Date(now.getFullYear(), quarterStartMonth, 0);
  const start = new Date(end.getFullYear(), end.getMonth() - 2, 1);
  const iso = (date) => date.toISOString().slice(0, 10);
  return { start: iso(start), end: iso(end) };
};

export const AcademyRunPanel = ({ configured, onRun }) => {
  const initial = lastQuarter();
  const [periodStart, setPeriodStart] = useState(initial.start);
  const [periodEnd, setPeriodEnd] = useState(initial.end);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try { await onRun({ period_start: periodStart, period_end: periodEnd }); }
    finally { setLoading(false); }
  };

  return (
    <section className="border-y border-slate-200 bg-white py-5" data-testid="academy-run-panel">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-xl">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
            <ShieldCheck className="h-4 w-4 text-emerald-600" /> Sincronizzazione controllata
          </div>
          <p className="mt-1 text-sm text-slate-600">Invia solo statistiche operative. Le proposte restano in attesa di revisione umana.</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
          <label className="text-xs font-semibold text-slate-600">Dal
            <input type="date" value={periodStart} onChange={(e) => setPeriodStart(e.target.value)}
              className="mt-1 block w-full rounded-md border px-3 py-2 text-sm" data-testid="academy-run-period-start" />
          </label>
          <label className="text-xs font-semibold text-slate-600">Al
            <input type="date" value={periodEnd} onChange={(e) => setPeriodEnd(e.target.value)}
              className="mt-1 block w-full rounded-md border px-3 py-2 text-sm" data-testid="academy-run-period-end" />
          </label>
          <Button onClick={submit} disabled={!configured || loading || !periodStart || !periodEnd}
            data-testid="academy-run-submit-button">
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Play className="mr-2 h-4 w-4" />}
            Avvia sincronizzazione
          </Button>
        </div>
      </div>
    </section>
  );
};
